import React, { Component, Fragment } from 'react';
import NavBar from './components/main/Navbar';
import Home from './components/main/Home';
import About from './components/main/About';
import Contact from './components/main/Contact'
//import Policy from './components/main/Policy'
import { BrowserRouter } from 'react-router-dom';

class App extends Component {
  render() {
    return (
      <Fragment>
        <NavBar />
        <Home />
        <About />
        <Contact />
      </Fragment>
      
    );
  }
}

export default App;
